import React, { useState } from "react";
import { Button, Datagrid, DateField, FunctionField, ListContextProvider, useList } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import HistoryIcon from "@mui/icons-material/History";
import { Typography } from "@mui/material";

const HistoryTable = ({ data }) => {
  const listContext = useList({ data });
  return (
    <ListContextProvider value={listContext}>
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        sx={{
          "& .RaDatagrid-headerCell": {
            textAlign: "left",
          },
        }}
      >
        <FunctionField
          label="Процент за обучаващ"
          render={rec => `${rec.trainerPercentage}%`}
        />
        <FunctionField
          label="Процент за БАПЗГ"
          render={rec => `${rec.bapzgPercentage}%`}
        />
        <FunctionField
          label="Процент за Университет"
          render={rec => `${rec.universityPercentage}%`}
        />
        <DateField
          source="effectiveFrom"
          label="В сила от"
          locales="bg-BG"
        />
        <DateField
          source="createdOn"
          label="Създадено на"
          locales="bg-BG"
          showTime
        />
      </Datagrid>
    </ListContextProvider>
  );
};

const HistoryDialog = () => {
  const [history, setHistory] = useState([]);

  const fetchHistory = async () => {
    try {
      const { data } = await dataProvider.customRequest(specialistRequests.getHealthcareCourseFeeDistributionHistory());
      setHistory(data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ConfirmModal
      onOpen={fetchHistory}
      titleContent={"История на разпределение на такси"}
      isConfirmButton={false}
      closeTitle="Затвори"
      dialogSize="md"
      triggerButton={
        <Button
          startIcon={<HistoryIcon />}
          label="История"
          variant="outlined"
        />
      }
    >
      {history?.length > 0 ? (
        <HistoryTable data={history} />
      ) : (
        <Typography
          color="text.secondary"
          sx={{ textAlign: "center", py: 2 }}
        >
          Няма история
        </Typography>
      )}
    </ConfirmModal>
  );
};

export default HistoryDialog;
